export enum TimesheetScheduleMode {
  AutoPrepareScheduleFromCalculation = 0,
  StartDayFromScheduleOption = 1,
}
